import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMenuOpen(false);
  };

  const navigateToAbout = () => {
    navigate('/about');
    setIsMenuOpen(false);
    window.scrollTo(0, 0);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled 
        ? 'bg-white/80 backdrop-blur-xl shadow-lg' 
        : 'bg-white/60 backdrop-blur-md'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-36">
          {/* Desktop Navigation LEFT */}
          <nav className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('services')}
              className="text-slate-700 hover:text-blue-600 transition-colors font-medium text-lg"
            >
              Leistungen
            </button>
            <button
              onClick={() => scrollToSection('partners')}
              className="text-slate-700 hover:text-blue-600 transition-colors font-medium text-lg"
            >
              Partner
            </button>
            <button
              onClick={navigateToAbout}
              className="text-slate-700 hover:text-blue-600 transition-colors font-medium text-lg"
            >
              Über uns
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-slate-700 hover:text-blue-600 transition-colors font-medium text-lg"
            >
              Kontakt
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
            >
              Jetzt Beratung anfragen
            </Button>
          </nav>

          {/* Mobile Menu Button LEFT */}
          <div className="lg:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-slate-700 hover:text-blue-600 transition-colors p-2"
            >
              {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>

          {/* Extra Large Logo RIGHT */}
          <div className="flex-shrink-0 cursor-pointer" onClick={() => navigate('/')}>
            <img
              src="https://customer-assets.emergentagent.com/job_8a8efe14-e280-43f8-81be-49615652987c/artifacts/4lypyyqs_Vivalo%20Logo%20ohne%20Slogan.png"
              alt="Vivalo Logo"
              className="h-28 md:h-36 lg:h-48 xl:h-56 w-auto transform transition-all duration-300 hover:scale-105"
            />
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-slate-200">
            <div className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('services')}
                className="text-slate-700 hover:text-blue-600 text-left font-medium text-lg py-2"
              >
                Leistungen
              </button>
              <button
                onClick={() => scrollToSection('partners')}
                className="text-slate-700 hover:text-blue-600 text-left font-medium text-lg py-2"
              >
                Partner
              </button>
              <button
                onClick={navigateToAbout}
                className="text-slate-700 hover:text-blue-600 text-left font-medium text-lg py-2"
              >
                Über uns
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-slate-700 hover:text-blue-600 text-left font-medium text-lg py-2"
              >
                Kontakt
              </button>
              <Button
                onClick={() => scrollToSection('contact')}
                className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white w-full mt-2"
              >
                Jetzt Beratung anfragen
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;